import React from "react";
import {
    ButtonContainer,
    ButtonTouchable,
    GradientBorder,
    IconWrapper,
    ButtonTitle,
} from "./ServiceButton.styles";

export type ServiceButtonProps = {
    Icon?: React.ComponentType<any>;
    imageUrl?: string;
    title: string;
    onClick: () => void;
};

const ServiceButton = ({
    Icon,
    imageUrl,
    title,
    onClick,
}: ServiceButtonProps) => {
    return (
        <ButtonContainer>
            <ButtonTouchable onClick={onClick}>
                <GradientBorder>
                    <IconWrapper>
                        {Icon ? (
                            <Icon />
                        ) : imageUrl ? (
                            <img src={imageUrl} alt={title} style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
                        ) : null}
                    </IconWrapper>
                </GradientBorder>
                <ButtonTitle>{title}</ButtonTitle>
            </ButtonTouchable>
        </ButtonContainer>
    );
};

export default ServiceButton;
